import { render, staticRenderFns } from "./WidddiProductList.vue?vue&type=template&id=729f9f88"
import script from "./WidddiProductList.vue?vue&type=script&lang=js"
export * from "./WidddiProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports